import React from 'react';
import Header from "../../Shared/Header/Header";
import MainInfo from "../MainInfo/MainInfo";
import InfoSection from "../InfoSection/InfoSection";
import Offer from "../Offer/Offer";
import Specialities from "../Specialities/Specialities";
import OurSpecialists from "../OurSpecialists/OurSpecialists";
import Process from "../Process/Process";
import ContactUs from "../ContactUs/ContactUs";
import Footer from "../../Shared/Footer/Footer";

const Home = () => {
  return (
    <>
      <Header />
      <MainInfo />
      <InfoSection />
      <Offer />
      <Specialities />
      <OurSpecialists />
      <Process />
      <ContactUs />
      <Footer />
    </>
  );
};

export default Home;
